const products = [
  {
    name: "HR Coils",
    description: "High-quality Hot Rolled Coils sourced directly from SAIL.",
  },
  {
    name: "CR Coils",
    description: "Cold Rolled Coils suitable for precision applications.",
  },
  {
    name: "GP & Chequered Coils",
    description: "Galvanized Plain and Chequered coils with excellent corrosion resistance.",
  },
  {
    name: "HSM Plates",
    description: "Heavy-duty HSM plates used in construction and fabrication.",
  },
  {
    name: "PM Plates",
    description: "Precision Mill plates for high-strength usage.",
  },
  {
    name: "HR Sheets",
    description: "Reliable Hot Rolled Sheets traded through our trusted supply network.",
  }
];

export default products;
